import { Link } from 'react-router';
import { motion, AnimatePresence } from 'motion/react';
import { useCookieConsent } from '@/hooks/useCookieConsent';

export function CookieBanner() {
  const { consent, accept, reject, ready } = useCookieConsent();

  const shouldShow = ready && consent === null;

  return (
    <AnimatePresence>
      {shouldShow && (
        <motion.div
          role="dialog"
          aria-label="Cookie consent"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-4 left-4 right-4 md:left-8 md:right-8 z-40 bg-surface-raised border border-border-strong p-5 md:p-6 flex flex-col md:flex-row md:items-center justify-between gap-5 max-w-[1440px] md:mx-auto"
        >
          <p className="text-sm leading-relaxed text-ink-secondary max-w-2xl">
            We only use one functional cookie - it remembers your choice below. No analytics, no tracking, no third parties.{' '}
            <Link to="/privacy-policy" className="text-accent underline underline-offset-4">
              Read the privacy policy
            </Link>
            .
          </p>
          <div className="flex gap-3 shrink-0">
            <button
              type="button"
              onClick={reject}
              className="font-sans text-sm underline underline-offset-4 hover:text-accent transition-colors cursor-pointer"
            >
              Reject
            </button>
            <button
              type="button"
              onClick={accept}
              className="bg-accent text-bg font-semibold text-sm px-5 py-3 rounded-full hover:bg-accent-hover transition-colors cursor-pointer"
            >
              Accept
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
